<script lang="ts">
	import SbRichtext from '../components/sbRichtext.svelte';
	import NewsletterInput from '../parts/newsletterInput.svelte';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import type { SbColor } from '../types';

	interface Props {
		content: ISbStoryData<{
			text: ISbRichtext;
			cta_label: string;
			cta_title: string;
			placeholder: string;
			bg_color: SbColor;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section class="bg-{content.bg_color || 'green-1'} py-12 lg:pb-18 lg:pt-16" use:editable={content}>
	<PageGrid16 margin gridClass="max-lg:gap-y-[26px]">
		<div
			class="col-span-full text-[24px]/[108%] tracking-[-.24px] text-white lg:col-start-1 lg:col-end-7 lg:text-[32px]/[110%] lg:tracking-[-.32px]"
		>
			<SbRichtext text={content.text} />
		</div>

		<NewsletterInput
			class="col-span-full lg:col-start-12 lg:col-end-[17]"
			placeholder={content.placeholder}
			name="email"
			id="email"
			title={content.cta_title}
			label={content.cta_label}
		></NewsletterInput>
	</PageGrid16>
</section>
